export const nonTradeViewMixin = {
  data() {
    return {
      branches: [],
      nonTradeFilterForm: {
        branch: '',
        fund: '',
        suffix: '',
        currency: '',
        addressedTo: '',
        netAmt: '',
        documentNo: '',
        tranType: '',
        tranDate: ''
      },
      nonTradeFilterLabel: {
        branch: 'Branch',
        fund: 'Fund',
        suffix: 'Suffix',
        currency: 'Currency',
        addressedTo: 'Addressed To',
        netAmt: 'Net Amount',
        documentNo: 'Document No.',
        tranType: 'Transaction Type',
        tranDate: 'Transaction Date'
      },
      nonTradeForm: {
        actionName: null,
        branch: null,
        accountNo: '',
        transactionType: 'Y',
        docAE: true,
        transactionDate: null,
        bankNo: null,
        documentNo: null,
        fund: null,
        accountNoSuffix: '',
        paymentMethod: null,
        gstIO: null,
        gstStatus: null,
        gstRate: null,
        isExistDocNo: null,
        chequeNo: null,
        name: null,
        addr1: null,
        addr2: null,
        addr3: null,
        addr4: null,
        postalCode: null,
        printDocument: null,
        prtCheque: false,
        amountCurr: null,
        amount: (0.00).toFixed(2),
        gstAmountCurr: null,
        amountCurrRate: (0.00).toFixed(2),
        gstAmountAE: true,
        gstAmount: (0.00).toFixed(2),
        netAmountCurr: null,
        netAmount: (0.00).toFixed(2),
        bankAmountCurr: null,
        bankAmountAE: true,
        bankAmount: (0.00).toFixed(2),
        bankAmountCurrRate: (0.00).toFixed(2),
        bankChargesCurr: null,
        bankCharges: (0.00).toFixed(2),
        bankTotalAmountCurr: null,
        bankTotalAmount: (0.00).toFixed(2),
        bankTotalLocalCurr: null,
        bankTotalLocalAE: true,
        bankTotalLocal: (0.00).toFixed(2),
        bankTotalLocalCurrRate: (0.00).toFixed(2),
        policyNo: null,
        claimNo: null,
        details: null,
        statement: null,
        department: null,
        insuredName: null,
        gstRegNo: null,
        taxInvoiceNo: null,
        payerBank: null,
        payersChequeNo: null,
        drawerName: null,
        creditCardNo: null,
        insdRefNo: null,
        oldFund: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      nonTradeLabel: {
        branch: 'Branch',
        transactionType: null,
        docAE: 'Autogenerate No.',
        transactionDate: 'Transaction Date',
        bankNo: 'Bank No.',
        documentNo: 'Document No',
        fund: 'Fund',
        accountNoSuffix: 'Suffix',
        paymentMethod: 'Payment Method',
        gstIO: 'GST IO',
        gstStatus: 'Status',
        gstRate: 'Rate',
        chequeNo: 'Cheque No.',
        name: 'Name',
        insured: 'Insured',
        intermediary: 'Intermediary',
        addr1: 'Address 1',
        addr2: 'Address 2',
        addr3: 'Address 3',
        addr4: 'Address 4',
        postalCode: 'Postal Code',
        printDocument: 'Print Document',
        prtCheque: 'Print Cheque',
        amountCurr: 'Amount Currency',
        amount: 'Amount',
        gstAmountCurr: 'GST Amount Currency',
        gstAmount: 'GST Amount',
        netAmountCurr: 'Net Amount Currency',
        netAmount: 'Net Amount',
        bankAmountCurr: 'Bank Amount Currency',
        bankAmount: 'Bank Amount',
        bankChargesCurr: 'Bank Charges Currency',
        bankCharges: 'Bank Charges',
        bankTotalAmountCurr: 'Bank Total Amount Currency',
        bankTotalAmount: 'Bank Total Amount',
        bankTotalLocalCurr: 'Bank Total Local Currency',
        bankTotalLocal: 'Bank Total Local',
        policyNo: 'Policy',
        claimNo: 'Claim No',
        details: 'Details',
        statement: 'Statement',
        department: 'Department',
        insuredName: 'Insured Name',
        gstRegNo: 'GST Reg No',
        taxInvoiceNo: 'Their Tax Invoice',
        payerBank: 'Payer Bank',
        payersChequeNo: 'Cheque No',
        drawerName: 'Drawer Name',
        creditCardNo: 'Credit Card No',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      gstIO: [
        { label: '', value: 'B' },
        { label: 'O - Output', value: 'O' },
        { label: 'I - Input', value: 'I' }
      ],
      printDocOpts: [
        { label: 'I - Immediately', value: 'I' },
        { label: 'L - Later', value: 'L' },
        { label: 'N - No', value: 'N' }
      ],
      tranTypes: [
        { label: 'Y - Receipt', value: 'Y' },
        { label: 'Z - Payment', value: 'Z' }
      ]
    }
  }
}
